var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('h1',{staticClass:"section-title"},[_vm._v(" "+_vm._s(_vm.$t("Thanks for verifying your e-mail"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }